const env = {
  MAPS_API_KEY: 'AIzaSyAgsFgz9KguIZUdL0vBQACiLVDSqmK2vTo',
  DEFAULT_MAP_CENTER: { lat: 51.5137137, lng: -0.1285204 }
}

export default env
